import ReportsListing from 'vcomponents/reports/listing/ReportsListing.vue';
import ReportsDashboard from 'vcomponents/reports/dashboard/ReportsDashboard.vue';

export default [
    {
        path: '/reports/listing',
        name: 'reports.listing',
        component: ReportsListing,
    },
    {
        path: '/reports/dashboard/:id',
        name: 'reports.dashboard',
        component: ReportsDashboard,
    },
];
